import { LoadingStatusType } from "@/enums/enums";
import { ConvertToActivityLog } from "@/service/activityLog/activityLogFacade";
import API from "@/service/Index";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({ namespaced: true })
export default class ActivityLog extends VuexModule {
  public activityLogList: Array<any> = [];
  public activityLogListLoadingStatus: LoadingStatusType = LoadingStatusType.None;

  get getActivityLogList(): Array<any> {
    return this.activityLogList;
  }

  get getActivityLogListLoadingStatus(): LoadingStatusType {
    return this.activityLogListLoadingStatus;
  }

  @Mutation
  public SetActivityLogList(activityLogList: Array<any>) {
    this.activityLogList = activityLogList;
  }

  @Mutation
  public SetActivityLogListLoadingStatus(status: LoadingStatusType) {
    this.activityLogListLoadingStatus = status;
  }

  @Action
  public DoCreateActivityLog(activityLog: Record<string, any>) {
    API.ActivityLog.DoCreateActivityLog(activityLog);
  }

  @Action
  public DoGetActivityLog(input: any) {
    if (this.activityLogListLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetActivityLogListLoadingStatus", LoadingStatusType.Loading);
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      API.ActivityLog.DoGetActivityLog(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const activityLogList = ConvertToActivityLog(res.data.data);
          this.context.commit("SetActivityLogList", activityLogList);
        }
        this.context.commit("SetActivityLogListLoadingStatus", LoadingStatusType.Success);
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }
}
